<template>
    <div id="callAndFeedback">
        <div class="feedback-box">
            <el-popover
            placement="left"
            width="60px"
            trigger="hover"
            >
                <div class="phoneleft" style="font-size:12px;color: #181818;">
                    <p class="top-text">联系电话</p>
                    <p class="bottom-num" style="color:#3062FF;margin-top:4px">400-8000-900</p>
                </div>
                <div class="box-style box-1" slot="reference">
                    <i class="iconfont icon-lianxidianhua" style="color:#181818;font-size:18px"></i>
                </div>
            </el-popover>
            <div class="center-line"></div>
            <el-popover
                placement="left"
                width="60px"
                trigger="hover"
                >
                <div style="font-size:12px;color: #181818;height:34px;line-height:34px">
                    <p>用户反馈</p>
                </div>
                <div class="box-style" slot="reference" @click="goFeedBack">
                    <i class="iconfont icon-yijianfankui" style="color:#181818;font-size:18px"></i>
                </div>
            </el-popover>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            
        }
    },
    methods:{
        goFeedBack(){
            window.open("http://feedback.pkpm.cn", '_blank');
        }
    },
    created(){
        
    }
}
</script>

<style scoped lang="scss">
    #callAndFeedback{
        position: fixed;
        top: 50%;
        margin-top: -100px;
        right: 48px;
        .feedback-box{
            width: 50px;
            height: 100px;
            box-sizing: border-box;
            padding: 10px 0px;
            background: #FFFFFF;
            box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.1);
            border-radius: 25px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            .box-style{
                width: 34px;
                height: 34px;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                &:hover{
                    background: #F4F6F8;
                    i{
                        color: #0069e0 !important;
                    }
                }
            }
            .center-line{
                height: 1px;
                width: 20px;
                background: #F3F4F7;
            }
        }
        .phoneleft{
            .top-text{
                color: #0069e0;
            }
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/CallAndFeedback.vue